import { Edit, ExpandMore, Public, Warning, WarningAmber } from "@mui/icons-material";
import { Accordion, AccordionDetails, AccordionSummary, Box, Checkbox, Chip, IconButton, TableCell, TableRow, Tooltip } from "@mui/material";
import { cloneDeep } from "lodash";
import { useEffect, useState } from "react";
import { IMaterialApprovedTableRow, MaterialContext } from "../../interfaces";
import { IImage } from "../../interfaces/Common/IImage";
import { Validate } from "../../utils/Validate";
import { MaterialImageDialog } from "../MaterialImageDialog";
import { MaterialInputDialog } from "../MaterialInputDialog";
import { MaterialIdentifiers } from "../Shared/MaterialIdentifiers";
import { MaterialInfo } from "../Shared/MaterialInfo";




export const MaterialApprovedTableRow: React.FC<IMaterialApprovedTableRow> = ({
    material,
    onAddDiscrepancy,
    onUpdate,
    onSelect,
    selectedMaterials,
    status
}) => {


    const [rowSelected, setRowSelected] = useState(selectedMaterials.some(x => x.materialId === material.materialId));

    const hasDiscrepancy = () => {
        if (material.discrepancy)
            if (material.discrepancy.length > 0)
                return true;

        return false;
    }

    const canSelect = () => {
        //selecting materials is not available on closed requests
        return status !== 6;
    }

    const updateImages = (images: IImage[]) => {

        let updatedMaterial = cloneDeep(material);

        updatedMaterial.images = images;
        onUpdate(updatedMaterial);
    }

    const selectRow = (checked: boolean) => {
        setRowSelected(checked);
        onSelect(material, checked);
    }

    useEffect(() => {

        setRowSelected(selectedMaterials.some(x => x.materialId === material.materialId))

    }, [selectedMaterials])

    return (
        <TableRow className="material-row" key={material.materialId}>
            <TableCell >
                <Box display="flex">

                    {canSelect() && 
                        <Checkbox style={{ maxHeight: '42px' }}
                            checked={rowSelected}
                            onChange={(_, checked) => selectRow(checked)}
                        />
                    }

                    <Accordion elevation={0}>
                        <AccordionSummary
                            expandIcon={<ExpandMore />}
                        >
                            <Box width="100%">
                                <p><strong>{material.l3}</strong></p>
                                <small>{material.l1?.value}</small>
                                <small>{material.l2?.value}</small>
                            </Box>
                            <Box display="flex" justifyContent="flex-end" alignItems="center" >
                                {material.statusId === 3 &&
                                    <Chip
                                        icon={<Public />}
                                        label="Material Out"
                                        color="warning"
                                        size="small"
                                    />
                                }
                                {material.statusId === 1 &&
                                    <Chip
                                        icon={<Edit />}
                                        label="Draft"
                                        color="info"
                                        size="small"
                                    />
                                }
                            </Box>
                        </AccordionSummary>
                        <AccordionDetails>
                            <MaterialInfo material={material} />
                        </AccordionDetails>
                    </Accordion>

                </Box>
            </TableCell>
            <TableCell>
                <p>{material.classes}</p>
            </TableCell>
            <TableCell>
                <p>{material.spareType?.value}</p>
            </TableCell>
            <TableCell>
                <MaterialIdentifiers material={material} />
            </TableCell>
            <TableCell>
                <p>{material.state?.value}</p>
            </TableCell>
            <TableCell>
                <p>
                    {material.quantity}
                    <span>({material.unitOfQuantity.value})</span>
                </p>
            </TableCell>

            <TableCell style={{ textAlign: "center" }}>
                {status === 3 &&
                    <MaterialInputDialog
                        entity={{ id: "", type: "STORAGEREQUEST" }}
                        context={MaterialContext.MaterialRowApproved}
                        onSubmitMaterial={(material, splitMaterial) => onUpdate(material, splitMaterial)}
                        material={material}
                        focus={Validate.materialLocationDetails(material)}
                        disabled={rowSelected}
                    />
                }


                <MaterialImageDialog
                    entityId={material.materialId}
                    images={material.images}
                    onImagesChanged={updateImages}
                    readonly={status > 3}
                />


                <Tooltip title="Discrepancies">
                    {
                        hasDiscrepancy() ?
                            <IconButton
                                onClick={onAddDiscrepancy}
                                color="error"
                            >
                                <Warning />
                            </IconButton>
                            :
                            <IconButton
                                onClick={onAddDiscrepancy}
                                color="default"
                            >
                                <WarningAmber />
                            </IconButton>
                    }
                </Tooltip>
            </TableCell>
        </TableRow >
    );
}

